/**
 * Custom DOM event dispatched by the axios interceptor when a 403 is received.
 * AuthProvider listens for this to re-fetch permissions (invalidation).
 */
export const AUTH_PERMISSIONS_STALE_EVENT = 'auth:permissions-stale';
